import { render } from "./Preferences.vue?vue&type=template&id=1dcc7336"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ThesauRex/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__